<template>
  <el-dialog
    :title="$t('activitiesManage.add.title')"
    :visible.sync="dialogVisible"
    width="650px"
    custom-class="figma-oa-dialog figma-activity-dialog"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="108px" :rules="rules" class="figma-oa-form">
      <el-form-item :label="$t('activitiesManage.add.titleLabel')" prop="title">
        <el-input v-model="form.title" :placeholder="$t('activitiesManage.add.titlePlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.typeCd')" prop="typeCd">
        <el-select v-model="form.typeCd" :placeholder="$t('activitiesManage.add.typeCdPlaceholder')" style="width:100%">
          <el-option v-for="item in typeCds" :key="item.typeCd" :label="item.typeName" :value="item.typeCd" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.selectCommunity')" prop="communityIds">
        <el-select
          v-model="form.communityIds"
          multiple
          filterable
          collapse-tags
          :placeholder="$t('activitiesManage.add.selectCommunityPlaceholder')"
          style="width:100%"
        >
          <el-option v-for="item in communitys" :key="item.communityId" :label="item.name" :value="item.communityId" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.headerImg')" prop="headerImg">
        <upload-image-url ref="uploadImage" :limit="1" @notifyUploadCoverImage="handleImageChange" />

      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.startTime')" prop="startTime">
        <el-date-picker v-model="form.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"          :placeholder="$t('activitiesManage.add.startTimePlaceholder')" style="width:100%"
           />
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.endTime')" prop="endTime">
        <el-date-picker v-model="form.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"          :placeholder="$t('activitiesManage.add.endTimePlaceholder')" style="width:100%"
           />
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.context')" prop="context">
        <rich-text-editor ref="richTextEditor" v-model="form.context" :placeholder="$t('activitiesManage.add.contextPlaceholder')" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="figma-dialog-footer">
      <el-button class="figma-cancel-btn" @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button class="figma-submit-btn" type="primary" @click="handleSubmit">{{ $t('common.submit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getEffectiveCommunityId, getMyEnteredCommunitys } from '@/api/community/communityApi'
import { saveActivities, listActivitiesType } from '@/api/oa/activitiesManageApi'
import UploadImageUrl from '@/components/upload/UploadImageUrl'
import RichTextEditor from "@/components/editor/RichTextEditor";
import { normalizeActivityTypes } from '@/utils/oaActivityTypes'

export default {
  name: 'AddActivitiesView',
  components: {
    UploadImageUrl,
    RichTextEditor
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        title: '',
        typeCd: '',
        headerImg: '',
        context: '',
        startTime: '',
        endTime: '',
        isMoreCommunity: '',
        communityId: '',
        communityIds: []
      },
      typeCds: [],
      communitys: [],
      rules: {
        title: [
          { required: true, message: this.$t('activitiesManage.validate.titleRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('activitiesManage.validate.titleMaxLength'), trigger: 'blur' }
        ],
        typeCd: [
          { required: true, message: this.$t('activitiesManage.validate.typeCdRequired'), trigger: 'change' }
        ],
        communityIds: [
          { type: 'array', required: true, message: this.$t('activitiesManage.validate.communityRequired'), trigger: 'change' }
        ],
        headerImg: [
          { required: true, message: this.$t('activitiesManage.validate.headerImgRequired'), trigger: 'change' }
        ],
        context: [
          { required: true, message: this.$t('activitiesManage.validate.contextRequired'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('activitiesManage.validate.startTimeRequired'), trigger: 'change' }
        ],
        endTime: [
          { required: true, message: this.$t('activitiesManage.validate.endTimeRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this.$refs.uploadImage && this.$refs.uploadImage.clearImages()
        this.loadActivitiesType()
        this.loadCommunitys()
        const communityId = getEffectiveCommunityId()
        this.form.communityIds = communityId ? [communityId] : []
      })
    },
    async loadCommunitys() {
      try {
        const res = await getMyEnteredCommunitys({ page: 1, row: 1000 })
        this.communitys = (res.communitys || []).filter(item => getEffectiveCommunityId(item.communityId))
      } catch (error) {
        console.error('获取小区失败:', error)
      }
    },
    async loadActivitiesType() {
      try {
        const params = {
          page: 1,
          row: 50,
          communityId: getEffectiveCommunityId()
        }
        const { data } = await listActivitiesType(params)
        this.typeCds = normalizeActivityTypes(data)
      } catch (error) {
        console.error('获取活动类型失败:', error)
      }
    },
    async getTypeCdByCommunity(communityId) {
      const currentType = this.typeCds.find(item => item.typeCd === this.form.typeCd)
      if (!currentType) {
        return this.form.typeCd
      }
      const { data } = await listActivitiesType({
        page: 1,
        row: 50,
        communityId
      })
      const targetTypes = normalizeActivityTypes(data)
      const targetType = targetTypes.find(item => item.typeName === currentType.typeName)
      return targetType ? targetType.typeCd : this.form.typeCd
    },
    handleImageChange(images) {
      this.form.headerImg = images.length > 0 ? images[0] : ''
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const communityId = getEffectiveCommunityId(this.form.communityIds[0])
            await saveActivities({
              ...this.form,
              communityId,
              communityIds: this.form.communityIds,
              isMoreCommunity: 'Y'
            })
            this.$message.success(this.$t('common.operationSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            console.error('保存活动失败:', error)
          }
        }
      })
    },
    handleClose() {
      if (this.$refs.richTextEditor) {
        this.$refs.richTextEditor.clear();
      }
      this.$refs.form.resetFields()
      this.form.communityIds = []
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .figma-oa-dialog {
  border-radius: 12px;
  margin-top: 113px !important;

  .el-dialog__header {
    height: 66px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    background: #EBF2FA;
    border-radius: 12px 12px 0 0;
    border-bottom: 1px solid #DCE6F5;
  }

  .el-dialog__title {
    color: #1D2129;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
  }

  .el-dialog__headerbtn {
    top: 24px;
    right: 24px;
  }

  .el-dialog__body {
    padding: 24px 24px 0;
  }

  .el-dialog__footer {
    padding: 22px 24px 28px;
  }

  .figma-oa-form {
    .el-form-item {
      margin-bottom: 20px;
    }

    .el-form-item__label {
      color: #1D2129;
      font-size: 14px;
      font-weight: 500;
      line-height: 38px;
    }

    .el-input__inner {
      height: 38px;
      line-height: 38px;
      border-radius: 10px;
      border: 1px solid #DCE6F5;
      color: #1D2129;
      font-size: 14px;
    }

    .el-input__inner::placeholder {
      color: #8C9BB4;
    }

    .rich-text-editor {
      border-color: #DCE6F5;
      border-radius: 10px;
      overflow: hidden;
    }

    .upload-image-container {
      gap: 0;

      .upload-button,
      .image-item,
      .image-item .el-image {
        width: 82px !important;
        height: 82px !important;
        border-radius: 8px;
      }

      .upload-button {
        border: 1px solid #0E76FF;
        background: rgba(14, 118, 255, 0.08);
        color: #0E76FF;
      }
    }
  }

  .figma-dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .figma-cancel-btn,
  .figma-submit-btn {
    width: 98px;
    height: 38px;
    border-radius: 10px;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
  }

  .figma-cancel-btn {
    color: #0E76FF;
    border-color: #0E76FF;
    background: #FFFFFF;
  }

  .figma-submit-btn {
    border-color: #0E76FF;
    background: #0E76FF;
  }
}
</style>
